import { FC, useCallback, useEffect, useMemo } from 'react';
import cls from 'classnames';
import { Button, ButtonSize, Colors } from '@lemon8/design';
import { useAtomValue } from 'jotai';
import { $CTAModal } from './atom';
import { useResetAtom } from 'jotai/utils';
import { useTranslation } from 'react-i18next';

import './style.scss';

export * from './atom';

export const CTAModal: FC = () => {
  const modelStatus = useAtomValue($CTAModal);
  const close = useResetAtom($CTAModal);
  const { t } = useTranslation();

  useEffect(() => {
    if (!modelStatus) {
      return;
    }

    window.Tea('wap_pop_window_show', {
      current_position: modelStatus.clickPosition,
      page_click_id: modelStatus.clickId,
    });
  }, [modelStatus]);

  const handleClickConfirm = useCallback(() => {
    if (!modelStatus) {
      return;
    }
    window.Tea('wap_pop_window_click', {
      current_position: modelStatus.clickPosition,
      page_click_id: modelStatus.clickId,
      click_result: 'install',
    });

    modelStatus.onConfirm();
    close();
  }, [modelStatus, close]);

  const handleClickCancel = useCallback(() => {
    if (!modelStatus) {
      return;
    }

    window.Tea('wap_pop_window_click', {
      current_position: modelStatus.clickPosition,
      page_click_id: modelStatus.clickId,
      click_result: 'cancel',
    });

    modelStatus.onCancel();
    close();
  }, [modelStatus, close]);

  const visibleCls = useMemo(
    () => ({
      shown: Boolean(modelStatus),
      hidden: !modelStatus,
    }),
    [modelStatus],
  );

  const modalContent = useMemo(() => {
    if (!modelStatus) {
      return null;
    }

    if (modelStatus.variant === 'primary') {
      return (
        <div className="cta-modal-content-primary">
          <div className="top_banner" />
          <div className="text">{t('sharing_popup_text')}</div>
          <Button
            className="install-button"
            size={ButtonSize.large}
            variant="Primary"
            title={t('sharing_popup_install')}
            onClick={handleClickConfirm}
          />
          <Button
            className="cancel-button"
            size={ButtonSize.large}
            variant="Text"
            title={t('sharing_popup_cancel')}
            titleColor={Colors.N100_60}
            onClick={handleClickCancel}
          />
        </div>
      );
    } else {
      return (
        <div className="cta-modal-content-post-unfold">
          <p className="title">{t('landing_postDetail_fullCaption_modal_title')}</p>
          <p className="description">{t('landing_postDetail_fullCaption_modal_desc')}</p>
          <Button
            className="install-button"
            size={ButtonSize.large}
            variant="Primary"
            title={t('landing_postDetail_fullCaption_modal_btn_openApp')}
            onClick={handleClickConfirm}
          />
          <Button
            className="cancel-button"
            size={ButtonSize.large}
            variant="Secondary"
            title={t('landing_postDetail_fullCaption_modal_btn_onBrowser')}
            titleColor={Colors.N100_60}
            onClick={handleClickCancel}
          />
        </div>
      );
    }
  }, [modelStatus]);

  return (
    <div className={cls('cta-modal', visibleCls)}>
      <div className={cls('cta-modal-mask', visibleCls)} />
      <div className={cls('cta-modal-content-anchor', visibleCls)}>
        <div className={cls('cta-modal-content', visibleCls)}>{modalContent}</div>
      </div>
    </div>
  );
};
